import Button from "../../../components/Button/Button";
import { customStyles } from "../../../components/Modal/ModalComponent";
import "./FastFormCondoUserModal.css";
import Modal from 'react-modal';
import { IoClose } from "react-icons/io5";
import { PiUserListBold } from "react-icons/pi";
import { ChevronLeft, ChevronRight, Home, IdCardLanyard, Info, Key, UserPlus } from "lucide-react";
import { RxEnter } from "react-icons/rx";
import { GoArrowSwitch } from "react-icons/go";
import { WizardStepTrigger } from "./WizardStepTrigger";
import { UserDataStep } from "./UserDataStep";
import { ProfileStep } from "./ProfileStep";
import { CredentialsStep } from "./CredentialStep";
import { UnitStep } from "./UnitStep";
import { AccessStep } from "./AccessStep";
import { useFastCondoUserStore } from "./context";
import { DynamicIcon } from "../../../components/DynamicIcon/DynamicIcon";
import { useTranslation } from "react-i18next";

export function FastFormCondoUserModal() {
   const { t } = useTranslation();
   const {
      open,
      step,
      createUser,
      totalSteps,
      isSubmitting,
      tagName,
      tagIcon,
      prevStep,
      nextStep,
      setStep,
      update,
      save,
      findUser,
      id,
   } = useFastCondoUserStore();

   function onRequestClose() {
      update("open", false);
   }

   return (
      <>
         <Button
            className={"button-blue reception-button"}
            label={t("monitoring.newAccess")}
            icon={<RxEnter size={18} />}
            onClick={() => update("open", true)}
         />
         <Modal
            isOpen={open}
            onRequestClose={onRequestClose}
            style={{
               ...customStyles,
               content: {
                  ...customStyles.content,
                  width: '890px',
                  minHeight: '540px',
                  maxWidth: '90dvw',
                  padding: '36px',
               }
            }}
            contentLabel={t("monitoring.newAccess")}
         >
            <button className="close-button absolute right-6 top-4" onClick={(e) => onRequestClose()}><IoClose /></button>
            <div className='modal-body wizard-fast-condo-user **:select-none!'>
               <h1 className="modal-text m-0! flex items-center flex-row justify-center gap-3">
                  {createUser ? (
                     <>
                        {tagIcon ? (
                           <DynamicIcon icon={tagIcon} size={18} />
                        ) : (
                           <UserPlus size={18} />
                        )}
                        {!!id ? "Atualizar" : t("common.new")} {tagName ? tagName.toLowerCase() : t("common.user")}
                     </>
                  ) : (
                     <>
                        <RxEnter size={18} />
                        {t("monitoring.newAccess")} {tagName ? t("common.of") + " " + tagName.toLowerCase() : ""}
                     </>
                  )}
               </h1>
               <div className="flex w-full flex-row items-center justify-center mt-4!">
                  <WizardStepTrigger
                     step={1}
                     label={t("common.data")}
                     validationFields={['name', 'cpf', 'rg', 'plate', 'phoneNumber']}
                     icon={PiUserListBold}
                  />
                  <WizardStepTrigger
                     step={2}
                     label={t("common.profile")}
                     validationFields={['selectedTag']}
                     icon={IdCardLanyard}
                  />
                  {createUser && (
                     <WizardStepTrigger
                        step={3}
                        label={t("common.credentials")}
                        validationFields={['credentials']}
                        icon={Key}
                     />
                  )}
                  <WizardStepTrigger
                     step={createUser ? 4 : 3}
                     label={t("common.unit")}
                     icon={Home}
                  />
                  <WizardStepTrigger
                     step={createUser ? 5 : 4}
                     label={t("common.access")}
                     validationFields={['customEndDate']}
                     icon={GoArrowSwitch}
                  />
               </div>
               <div className="mt-12! w-full box-border!">
                  {step === 1 && (
                     <UserDataStep />
                  )}
                  {step === 2 && (
                     <ProfileStep />
                  )}
                  {createUser && step === 3 && (
                     <CredentialsStep />
                  )}
                  {step === (createUser ? 4 : 3) && (
                     <UnitStep />
                  )}
                  {step === (createUser ? 5 : 4) && (
                     <AccessStep />
                  )}
               </div>
               <div className="absolute bottom-6 left-6 w-[calc(100%-3rem)] flex justify-between gap-3">
                  <Button
                     className={`button-white ${step > 1 ? '' : 'opacity-0! pointer-events-none!'}`}
                     icon={<ChevronLeft />}
                     label={t("common.previous")}
                     onClick={() => prevStep()}
                  />
                  {createUser && (
                     <div className="flex items-center text-center text-(--textColor) gap-2 opacity-40">
                        <Info size={18} />
                        {t("monitoring.manualAccessInfo")}
                     </div>
                  )}
                  {step < totalSteps && (
                     <Button
                        className="button-white"
                        icon={<ChevronRight />}
                        iconPosition="right"
                        label={t("common.next")}
                        onClick={() => nextStep()}
                     />
                  )}
                  {step === totalSteps && (
                     <div className="w-28.75! h-fit flex justify-end">
                        <Button
                           className="button-blue"
                           label={isSubmitting ? t("common.saving") : t("common.save")}
                           onClick={e => save()}
                           disabled={isSubmitting}
                        />
                     </div>
                  )}
               </div>
            </div>
         </Modal>
      </>
   );
}